import { render } from "./background-job-modal.vue?vue&type=template&id=640ea760&scoped=true"
import script from "./background-job-modal.vue?vue&type=script&lang=js"
export * from "./background-job-modal.vue?vue&type=script&lang=js"

import "./background-job-modal.vue?vue&type=style&index=0&id=640ea760&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-640ea760"]])

export default __exports__